const RequestStatus = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
} as const;

type RequestStatus = typeof RequestStatus[keyof typeof RequestStatus];

export { RequestStatus };
